// extracted by mini-css-extract-plugin
export default {"root":"IndexLayout_root__bbS84","content":"IndexLayout_content__ACepr"};